import { createApi } from '@reduxjs/toolkit/query/react'
import { PRIVACY_STATEMENT_MODAL_TEXT } from 'shared/constants/customtexts'
import { ICustomText } from 'shared/models/CustomText'
import axiosBaseQuery from 'shared/utils/axiosBaseQuery'

const customtextApi = createApi({
  reducerPath: 'customtexts',
  baseQuery: axiosBaseQuery({ baseUrl: '/customtext/bbltexts/' }),
  endpoints: (build) => ({
    getCustomTexts: build.query<ICustomText[], void>({
      async queryFn(_arg, _api, _extraOptions, baseQuery) {
        const baseline = await baseQuery({
          url: 'Portal',
          method: 'GET',
        })

        if (baseline.error) {
          return { error: baseline.error }
        }

        const privacyStatementText = await baseQuery({
          url: `Minside/${PRIVACY_STATEMENT_MODAL_TEXT}`,
          method: 'GET',
        })

        if (privacyStatementText.error) {
          return { error: privacyStatementText.error }
        }

        return {
          data: [
            ...(baseline.data as ICustomText[]),
            privacyStatementText.data as ICustomText,
          ],
        }
      },
    }),
  }),
})

export default customtextApi
export const { useLazyGetCustomTextsQuery } = customtextApi
